<template>
  <div class="generic-dialog-overlay" v-if="model?.show"></div>
  <div class="modal fade generic-dialog" ref="thisDialog" data-bs-keyboard="false" data-bs-backdrop="static" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" :class="model.type == 'warning' ? 'bg-warning text-dark' : (model.type == 'danger' ? 'bg-danger text-white' : 'bg-primary text-white')">
          <h5 class="modal-title" v-html="model.title"></h5>
          <button v-if="model.cancel" type="button" :class="model.type == 'warning' ? 'btn-close' : 'btn-close btn-close-white'" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-center" v-html="model.body"/>
        <div v-if="model.button || model.cancel" class="modal-footer">
          <button v-if="model.button" type="button" class="btn btn-primary bg-gradient" data-bs-dismiss="modal" @click="accepted=true">{{model.button}}</button>
          <button v-if="model.cancel" type="button" class="btn btn-secondary bg-gradient" data-bs-dismiss="modal">{{model.cancel}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'modelValue',
    ],

    emits: [
      'update:modelValue',
    ],

    data: function() {
      return {
        dialog: null,
        model: {},
        accepted: false,
      }
    },

    mounted: function() {
      /*global bootstrap*/
      /*eslint no-undef: "error"*/
      this.dialog = new bootstrap.Modal(this.$refs.thisDialog, {})

      this.$refs.thisDialog.addEventListener('hidden.bs.modal', () => {
        this.model.show = false

        this.$emit('update:modelValue', this.model)

        this.onClose()
      }, false)
    },

    watch: {
      modelValue: {
        handler: function() {
          if ( this.dialog && this.model ) {
            this.model = this.modelValue
            if ( this.model.show ) {
              this.dialog.show()
              this.accepted = false
            } else {
              this.dialog.hide()
            }
          }
        },
        deep: true,
        immediate: true,
      }
    },

    methods: {
      onClose: function() {
        if ( typeof this.model.onClose == 'function' ) {
          this.model.onClose(this.accepted)
        }
      },
    },
  }
</script>
